<template>
    <div>
        <list-filter data-aos="fade-up" class="mb-30px mb-md-68px" />

        <v-row data-aos="fade-up">
            <!-- S: recent -->
            <v-col v-for="item in items" :key="item._id" cols="6" md="4">
                <v-card tile flat color="transparent" class="list-item v-card--none-active-bg plus-btn-card" @click="selectedVideoId = item.videoId">
                    <div class="list-item__thumb-wrap">
                        <v-img :src="item.thumbnail" max-width="464" :aspect-ratio="16 / 9" class="list-item__thumb w-100" />
                    </div>
                    <div class="py-18px py-md-36px">
                        <u-txt-default class="txt--sm txt--light line-height-14">
                            <v-row align="center" class="row--xxs">
                                <v-col>
                                    <p>{{ item.label }}</p>
                                </v-col>
                                <v-col cols="12" md="auto">
                                    <!-- <p>{{ $dayjs(item.createdAt).format("YYYY.MM.DD") }}</p> -->
                                </v-col>
                            </v-row>
                        </u-txt-default>
                        <u-tit-medium class="tit--sm line-height-14 text-truncate-2 mt-8px mt-md-16px">
                            {{ item?.title }}
                        </u-tit-medium>
                    </div>
                </v-card>
            </v-col>
            <!-- E: recent -->

            <v-col cols="12" v-if="showsMore">
                <v-layout justify-center>
                    <v-progress-circular indeterminate size="100" width="5" v-intersect="onIntersectMore" />
                </v-layout>
            </v-col>
        </v-row>

        <v-bottom-sheet :value="!!selectedVideoId" eager fullscreen content-class="mw-100 h-100" max-width="100%" width="100%">
            <v-btn x-large absolute top right icon text color="white" style="z-index: 10" @click="selectedVideoId = null">
                <icon-close />
            </v-btn>
            <v-responsive max-width="1440" :aspect-ratio="1440 / 810" v-if="!!selectedVideoId">
                <iframe :src="'https://www.youtube.com/embed/' + selectedVideoId" class="w-100 h-100 d-block" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen />
            </v-responsive>
        </v-bottom-sheet>
    </div>
</template>

<script>
import api from "@/api";
import ListFilter from "./list/list-filter.vue";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";
import UTitMedium from "@/components/publish/styles/typography/u-tit-medium.vue";
import UTxtDefault from "@/components/publish/styles/typography/u-txt-default.vue";
import UTxtMedium from "@/components/publish/styles/typography/u-txt-medium.vue";
import IconClose from "@/components/publish/styles/icons/icon-close.vue";

export default {
    components: {
        ListFilter,
        UTitDefault,
        UTitMedium,
        UTxtDefault,
        UTxtMedium,
        IconClose,
    },
    data: () => ({
        medias: [],
        summary: { totalCount: 0 },

        page: 1,
        limit: 30,

        loading: false,
        selectedVideoId: null,
    }),
    computed: {
        showsMore() {
            return 0 < this.summary.totalCount && this.page * this.limit < this.summary.totalCount;
        },
        headers() {
            return {
                skip: (this.page - 1) * this.limit,
                limit: this.limit,
            };
        },
        params() {
            let { ...query } = this.$route.query;

            query.type = "목록";

            return query;
        },
        items() {
            return this.medias;
        },
    },
    methods: {
        async init() {
            this.medias = [];
            this.summary = { totalCount: 0 };
            this.loading = false;
            this.page = 1;
        },
        async search() {
            if (this.loading) return;

            try {
                let { headers, params } = this;
                let { summary, medias } = await api.v1.media.gets({
                    headers,
                    params,
                });

                this.medias = this.medias.concat(...medias);
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
        onIntersectMore(entries, observer, isIntersecting) {
            if (!isIntersecting) return;
            if (this.loading) return;
            this.page += 1;
            this.search();
        },
    },
    watch: {
        params() {
            this.init().then(this.search);
        },
    },
    mounted() {
        this.init().then(this.search);
    },
};
</script>

<style lang="scss" scoped>
.list-item {
    &__thumb {
        &-wrap {
            overflow: hidden;
            position: relative;
            &::after {
                content: "";
                display: block;
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background-color: rgba(13, 25, 50, 0.4);
                opacity: 0;
                visibility: hidden;
                transition: 0.4s ease-out;
            }
        }
        transform: scale(1);
        transition: 0.4s ease-out;
    }
}
::v-deep {
    .v-bottom-sheet {
        background-color: rgba(0, 0, 0, 0.8) !important;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    ::v-deep {
        .v-bottom-sheet {
            .v-btn--absolute.v-btn--top.v-btn--right {
                top: 50px;
                right: 50px;
            }
        }
    }
}
@media (min-width: 1024px) {
    .list-item:hover {
        .list-item__thumb {
            &-wrap {
                &::after {
                    opacity: 1;
                    visibility: visible;
                }
            }
            transform: scale(1.2);
        }
    }
}
@media (min-width: 1200px) {
}
</style>
